import { BROADCAST_DRAG_SOURCE } from '../../Types';

export default isDragging => {
  return dispatch => {
    const action = {
      type: BROADCAST_DRAG_SOURCE,
      payload: isDragging
    };

    return dispatch(action);
  };
};
